/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: actions.ts
 * Class: actions.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { ActionContext, ActionTree } from 'vuex';
import { AxiosResponse } from 'axios';
import { RootState } from '../types';
import { ApiEndpointEnum, getApiRequestConfig } from '@a/config/network';
import {
  ActivateCheckResponse, CloudResponse, CloudState, RenewRequest, RenewResponse,
} from './types';

export const actions: ActionTree<CloudState, RootState> = {
  fetchClouds({ commit }): Promise<CloudResponse> {
    commit('cloudsLoading');

    return new Promise((resolve, reject) => {
      this.state.$http.get('contract/clouds', getApiRequestConfig(ApiEndpointEnum.CloudAPI))
        .then((response: AxiosResponse<CloudResponse>) => {
          const payload: CloudResponse = response && response.data;
          commit('cloudsLoaded', payload);
          resolve(payload);
        }, (error) => {
          commit('cloudsError', error);
          reject(error);
        });
    });
  },
  /**
   * Asks whether the customer can afford to reactivate a deactivated cloud, before
   * sending them to /activateOrder/ — which books a new paid term and would
   * otherwise fail on an empty balance after the confirmation. Mirrors what the
   * gamecloud dashboard's own Reactivate button does.
   *
   * Deliberately commits nothing: this is a read used to decide which dialog to
   * show, and the reactivation itself leaves the SPA.
   */
  async activateCheck(
    _context: ActionContext<CloudState, RootState>,
    orderId: number,
  ): Promise<ActivateCheckResponse> {
    const response: AxiosResponse<ActivateCheckResponse> = await this.state.$http.post(
      `activateCheck/${orderId}`,
      {},
      getApiRequestConfig(ApiEndpointEnum.Gamecloud),
    );

    return response.data;
  },
  renew({ commit }, request: RenewRequest): Promise<RenewResponse> {
    commit('renewLoading');

    return new Promise((resolve, reject) => {
      this.state.$http.post(
        'contract/renew',
        {
          orderId: request.orderId,
          status: request.status,
        },
        getApiRequestConfig(ApiEndpointEnum.CloudAPI),
      )
        .then((response: AxiosResponse<RenewResponse>) => {
          const payload = response && response.data;
          commit('cloudRenewUpdated', payload);
          commit('renewLoaded', payload);
          resolve(payload);
        }, (error) => {
          commit('renewError', error);
          reject(error);
        });
    });
  },
};
